module.exports = __webpack_public_path__ + "media/images/true-sign-c7ff251ad7714b0990dd6d4f25a732b8.png";